// --- variables
import { API_URL } from "variables";

// --- utilities
import { DataTable, Form, HttpRequest, SweetAlert } from "utilities";

// -----------------------
// Validation config
// -----------------------
const ElementSelector = [
  { id: "role_id" },
  {
    id: "role_name",
    validation: { required: true },
  },
];

const ElementEvents = ["input", "blur"];

const Role = (() => {
  // -----------------------
  // DOM refs
  // -----------------------
  const $modal = $("#modalRole");
  const $form = $modal.find(".js-form-role");
  const $saveBtn = $form.find(".js-role-save");
  let accessItemsLoaded = false;

  // -----------------------
  // DataTable
  // -----------------------
  const handleRunDataTable = () => {
    DataTable.custom(
      {
        selector: "js-data-role",
        url: API_URL.roleGet,
        method: "POST",
      },
      [
        { id: "dateRange", event: "change" },
        { id: "status", event: "change" },
        { id: "search", event: "keyup" },
      ],
      [
        {
          targets: 4,
          className: "text-center",
          render: (data) => {
            const icon = data.status === "1" ? "ph-eye" : "ph-eye-slash";
            return `
              <button class="btn btn-sm btn-default btn-trans js-update-status"
                data-id="${data.id}" data-status="${data.status}">
                <i class="ph ${icon}"></i>
              </button>
              <button class="btn btn-sm btn-default btn-trans js-edit-data"
                data-id="${data.id}">
                <i class="ph ph-pencil-simple"></i>
              </button>
              <button class="btn btn-sm btn-danger btn-trans js-delete-data"
                data-id="${data.id}">
                <i class="ph ph-trash"></i>
              </button>`;
          },
        },
      ]
    );
  };

  // -----------------------
  // Helpers
  // -----------------------
  const resetModal = () => {
    $form[0]?.reset();
    $("#role_id").val("");
    $("#is_full_permission").val("0");
    $("#is_full_access").val("0");

    // Reset semua checkbox
    $("#perm_full, #access_full, .perm-item, .access-item").prop(
      "checked",
      false
    );

    // Enable semua checkbox
    $(".perm-item, .access-item").prop("disabled", false);

    // Reset access list
    const $accessList = $("#access-list");
    $accessList.find(".perm-pill").not(":has(#access_full)").remove();

    accessItemsLoaded = false;

    $modal.find(".form-text.text-danger").addClass("d-none");
  };

  // -----------------------
  // Render Access from DB
  // -----------------------
  const renderAccessFromDB = async () => {
    if (accessItemsLoaded) return; // Skip jika sudah loaded

    const $accessList = $("#access-list");

    try {
      const res = await HttpRequest.custom({
        url: API_URL.roleMenus,
        method: "POST",
      });

      if (!res || res.code !== 200 || !Array.isArray(res.data)) {
        console.error("Failed to load menus:", res);
        SweetAlert.config("Failed to load access menus", "error");
        return;
      }

      // Filter hanya menu aktif dan bukan root/parent
      const activeMenus = res.data.filter((menu) => menu.status === "1");

      // Sort berdasarkan sorting atau id
      activeMenus.sort((a, b) => (a.sorting || a.id) - (b.sorting || b.id));

      // Tambahkan menu items
      activeMenus.forEach((menu) => {
        $accessList.append(`
          <label class="perm-pill">
            <span class="perm-label">
              <i class="${menu.icon || "ph ph-folder"}"></i>
              ${menu.name}
            </span>
            <input
              type="checkbox"
              class="access-item"
              name="access[]"
              value="${menu.route}"
              data-name="${menu.name}"
            />
          </label>
        `);
      });

      accessItemsLoaded = true;
    } catch (err) {
      console.error("Failed to load access menus:", err);
      SweetAlert.config("Failed to load access menus", "error");
    }
  };

  // -----------------------
  // Load Role Data
  // -----------------------
  const loadRoleData = async (roleId) => {
    try {
      const formData = new FormData();
      formData.append("role_id", roleId);

      const res = await HttpRequest.custom({
        url: API_URL.roleGet,
        method: "POST",
        data: formData,
        isFormData: true,
      });

      if (res?.code === 200) {
        return res.data;
      } else {
        console.error("Role data not found:", res);
        SweetAlert.config(res?.message || "Role data not found", "error");
        return null;
      }
    } catch (err) {
      console.error("Error loading role data:", err);
      SweetAlert.config("Error loading role data", "error");
      return null;
    }
  };

  // -----------------------
  // Open Add Role
  // -----------------------
  const openAddRoleModal = async () => {
    resetModal();
    await renderAccessFromDB();

    $("#modalRoleLabel").text("Add Role");
    $saveBtn.text("Add").data("mode", "add");

    $modal.modal("show");
  };

  // -----------------------
  // Open Edit Role
  // -----------------------
  const openEditRoleModal = async (roleId) => {
    resetModal();

    // Tampilkan loading state
    $saveBtn.prop("disabled", true).addClass("is-loading");

    try {
      // Load access menus dulu
      await renderAccessFromDB();

      // Load role data
      const roleData = await loadRoleData(roleId);

      if (!roleData) {
        $modal.modal("hide");
        return;
      }

      // Set modal title dan button
      $("#modalRoleLabel").text("Edit Role");
      $saveBtn.text("Save").data("mode", "edit");

      // Set basic role data
      $("#role_id").val(roleData.role.id || "");
      $("#role_name").val(roleData.role.name || "");

      // Check apakah Full Permission
      const isFullPermission = roleData.is_full_permission == 1;
      if (isFullPermission) {
        $("#perm_full").prop("checked", true);
        $(".perm-item").prop("checked", true).prop("disabled", true);
        $("#is_full_permission").val("1");
      } else {
        // Set individual permissions
        const permissions = roleData.permissions || [];
        console.log("Permissions to set:", permissions);

        permissions.forEach((perm) => {
          $(`.perm-item[value="${perm}"]`).prop("checked", true);
        });
        $("#is_full_permission").val("0");
      }

      // Check apakah Full Access
      const isFullAccess = roleData.is_full_access == 1;
      if (isFullAccess) {
        $("#access_full").prop("checked", true);
        $(".access-item").prop("checked", true).prop("disabled", true);
        $("#is_full_access").val("1");
      } else {
        // Set individual access
        const access = roleData.access || [];
        console.log("Access to set:", access);

        access.forEach((acc) => {
          // Cari checkbox dengan value yang sesuai
          const $accessItem = $(`.access-item[value="${acc}"]`);
          if ($accessItem.length) {
            $accessItem.prop("checked", true);
          } else {
            // Jika tidak ditemukan dengan route, coba dengan name
            const $accessByName = $(`.access-item[data-name="${acc}"]`);
            if ($accessByName.length) {
              $accessByName.prop("checked", true);
            }
          }
        });
        $("#is_full_access").val("0");
      }

      // Update full checkbox state
      updateFullCheckboxState();

      $modal.modal("show");
    } catch (error) {
      console.error("Error opening edit modal:", error);
      SweetAlert.config("Failed to open edit modal", "error");
    } finally {
      $saveBtn.prop("disabled", false).removeClass("is-loading");
    }
  };

  // -----------------------
  // Update Full Checkbox State
  // -----------------------
  const updateFullCheckboxState = () => {
    // Update permission full checkbox
    const permItems = $(".perm-item");
    const allPermsChecked =
      permItems.length > 0 &&
      permItems.length === permItems.filter(":checked").length;
    $("#perm_full").prop("checked", allPermsChecked);

    // Update access full checkbox
    const accessItems = $(".access-item");
    const allAccessChecked =
      accessItems.length > 0 &&
      accessItems.length === accessItems.filter(":checked").length;
    $("#access_full").prop("checked", allAccessChecked);
  };

  // expose
  window.RoleModal = {
    openAdd: openAddRoleModal,
    openEdit: openEditRoleModal,
  };

  // -----------------------
  // Toggle handlers
  // -----------------------
  const bindModalToggleHandlers = () => {
    // Full Permission toggle
    $modal.on("change", "#perm_full", function () {
      const isChecked = $(this).is(":checked");
      $(".perm-item").prop("checked", isChecked).prop("disabled", isChecked);
      $("#is_full_permission").val(isChecked ? "1" : "0");

      // Jika dicentang, update semua checkbox permissions
      if (isChecked) {
        $(".perm-item").each(function () {
          $(this).prop("checked", true);
        });
      }
    });

    // Individual permission toggle
    $modal.on("change", ".perm-item", function () {
      // Update full checkbox state
      updateFullCheckboxState();

      // Update hidden field
      const allChecked =
        $(".perm-item").length > 0 &&
        $(".perm-item").length === $(".perm-item").filter(":checked").length;
      $("#is_full_permission").val(allChecked ? "1" : "0");

      // Jika semua dicentang, update full checkbox
      if (allChecked) {
        $("#perm_full").prop("checked", true);
        $(".perm-item").prop("disabled", true);
      } else {
        $("#perm_full").prop("checked", false);
        $(".perm-item").prop("disabled", false);
      }
    });

    // Full Access toggle
    $modal.on("change", "#access_full", function () {
      const isChecked = $(this).is(":checked");
      $(".access-item").prop("checked", isChecked).prop("disabled", isChecked);
      $("#is_full_access").val(isChecked ? "1" : "0");

      // Jika dicentang, update semua checkbox access
      if (isChecked) {
        $(".access-item").each(function () {
          $(this).prop("checked", true);
        });
      }
    });

    // Individual access toggle
    $modal.on("change", ".access-item", function () {
      // Update full checkbox state
      updateFullCheckboxState();

      // Update hidden field
      const allChecked =
        $(".access-item").length > 0 &&
        $(".access-item").length ===
          $(".access-item").filter(":checked").length;
      $("#is_full_access").val(allChecked ? "1" : "0");

      // Jika semua dicentang, update full checkbox
      if (allChecked) {
        $("#access_full").prop("checked", true);
        $(".access-item").prop("disabled", true);
      } else {
        $("#access_full").prop("checked", false);
        $(".access-item").prop("disabled", false);
      }
    });
  };

  // -----------------------
  // Collect Form Data
  // -----------------------
  const collectFormData = () => {
    const formData = new FormData();

    // Basic data
    const roleId = $("#role_id").val();
    if (roleId) {
      formData.append("role_id", roleId);
    }

    formData.append("name", $("#role_name").val().trim());
    formData.append("is_full_permission", $("#is_full_permission").val());
    formData.append("is_full_access", $("#is_full_access").val());

    // Collect permissions
    const permissions = [];
    $(".perm-item:checked").each((_, el) => {
      permissions.push(el.value);
    });

    // Collect access
    const access = [];
    $(".access-item:checked").each((_, el) => {
      access.push(el.value);
    });

    // Kirim sebagai JSON string untuk konsistensi dengan controller
    formData.append("permissions", JSON.stringify(permissions));
    formData.append("access", JSON.stringify(access));

    return formData;
  };

  // -----------------------
  // Validate Form
  // -----------------------
  const validateForm = () => {
    const name = $("#role_name").val().trim();
    if (!name) {
      $("#role-name-error").removeClass("d-none");
      $("#role_name").focus();
      return false;
    }

    // Jika bukan full access, pastikan minimal satu access dipilih
    const isFullAccess = $("#is_full_access").val() === "1";
    const hasAccess = $(".access-item:checked").length > 0;

    if (!isFullAccess && !hasAccess) {
      SweetAlert.config("Please select at least one access menu", "warning");
      return false;
    }

    return true;
  };

  // -----------------------
  // Submit form
  // -----------------------
  const bindModalSubmit = () => {
    $form.on("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Validasi form
      if (!validateForm()) {
        return;
      }

      // Kumpulkan data
      const formData = collectFormData();

      // Debug form data
      debugFormData(formData);

      // Tentukan URL berdasarkan mode
      const mode = $saveBtn.data("mode");
      const url = mode === "edit" ? API_URL.roleEdit : API_URL.roleAdd;

      try {
        $saveBtn.prop("disabled", true).addClass("is-loading");

        const res = await HttpRequest.custom({
          url,
          method: "POST",
          data: formData,
          isFormData: true,
        });

        if (res?.code === 200) {
          $modal.modal("hide");
          SweetAlert.config(res.message, "success");
          if ($(".js-data-role").length) {
            $(".js-data-role").DataTable().ajax.reload(null, false);
          }
        } else {
          SweetAlert.config(res?.message || "Failed to save role", "error");
        }
      } catch (err) {
        console.error("Save role error:", err);
        SweetAlert.config("Save failed. Please try again.", "error");
      } finally {
        $saveBtn.prop("disabled", false).removeClass("is-loading");
      }
    });
  };

  // -----------------------
  // Bind Edit Data
  // -----------------------
  const bindEditData = () => {
    $(document).on("click", ".js-edit-data", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const roleId = $(this).data("id");
      if (roleId) {
        openEditRoleModal(roleId);
      } else {
        SweetAlert.config("Invalid role ID", "error");
      }
    });
  };

  // -----------------------
  // Bind Delete Data
  // -----------------------
  const handleDeleteData = () => {
    $("body").on("click", ".js-delete-data", (e) => {
      const _this = $(e.currentTarget);
      let formData = new FormData();
      const id = _this.attr("data-id");

      formData.append("role_id", id);

      const data = {
        url: API_URL.roleDelete,
        method: "POST",
        data: formData,
      };

      Form.deleteData(data);
    });
  };

  // -----------------------
  // Bind Update Status
  // -----------------------
  const bindUpdateStatus = () => {
    $(document).on("click", ".js-update-status", function (e) {
      e.preventDefault();
      const roleId = $(this).data("id");
      const currentStatus = $(this).data("status");
      const newStatus = currentStatus === "1" ? "0" : "1";

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("status", newStatus);

      HttpRequest.custom({
        url: API_URL.roleUpdateStatus,
        method: "POST",
        data: formData,
        isFormData: true,
      })
        .then((res) => {
          if (res?.code === 200) {
            SweetAlert.config("Status updated successfully", "success");
            if ($(".js-data-role").length) {
              $(".js-data-role").DataTable().ajax.reload(null, false);
            }
          } else {
            SweetAlert.config(
              res?.message || "Failed to update status",
              "error"
            );
          }
        })
        .catch((err) => {
          console.error("Update status error:", err);
          SweetAlert.config("Update failed", "error");
        });
    });
  };

  // -----------------------
  // Debug Helper
  // -----------------------
  const debugFormData = (formData) => {
    const data = {};
    for (let [key, value] of formData.entries()) {
      if (data[key]) {
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    }
    console.log("FormData to send:", data);
    return data;
  };

  // -----------------------
  // Init
  // -----------------------
  const init = () => {
    // Reset loaded flag
    accessItemsLoaded = false;

    if ($(".js-data-role").length) {
      handleRunDataTable();
      bindEditData();
      handleDeleteData();
      bindUpdateStatus();
    }

    if ($(".js-form-role").length) {
      Form.validation(ElementEvents, ElementSelector);
      bindModalToggleHandlers();
      bindModalSubmit();

      // Bind add role button
      $(document).on("click", ".js-open-add-role", (e) => {
        e.preventDefault();
        openAddRoleModal();
      });
    }
  };

  return { init };
})();

export default Role;
